import React, { useEffect, useState } from "react";
import BaseModalAnimated from "./BaseModalAnimated";
import CustomButton from "../form/CustomButton";

const PreviewPDF = ({ modal, setModal }) => {
  const [fileURL, setFileURL] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let objectURL = null;

    const handleSignedURL = async () => {
      if (!modal.url) return;

      setLoading(true);

      try {
        if (modal.firma) {
          // Cuando es una URL firmada, la descargamos como blob
          const response = await fetch(modal.url);
          if (!response.ok) {
            throw new Error("Failed to fetch the file.");
          }
          const blob = await response.blob();
          objectURL = URL.createObjectURL(blob);
          setFileURL(objectURL);
        } else {
          // Si no es firmada, usamos la URL directamente
          setFileURL(modal.url);
        }
      } catch (error) {
        console.error("Error fetching the signed URL:", error);
        setFileURL(null);
      } finally {
        setLoading(false);
      }
    };

    handleSignedURL();

    // Cleanup del objectURL
    return () => {
      if (objectURL) {
        URL.revokeObjectURL(objectURL);
      }
    };
  }, [modal.url, modal.firma]);

  const handleClose = () => {
    setModal({ ...modal, show: false });
  };

  return (
    <BaseModalAnimated setModal={setModal} modal={modal}>
      <div
        className="
          flex flex-col
          
          bg-cs-bg
          rounded-2xl
          overflow-hidden
          border border-cs-border
        "
      >
        {/* Header */}
        

        {/* Body */}
        <div className="flex-1 flex flex-col gap-3">
          <div
            className="
              flex-1
              bg-cs-surface
              rounded-xl
              border border-cs-border
              overflow-hidden
              flex items-center justify-center
            "
          >
            {loading && (
              <div className="flex flex-col items-center gap-2 text-xs text-cs-muted">
                <span className="material-symbols-outlined text-lg animate-spin">
                  progress_activity
                </span>
                <span>Loading preview…</span>
              </div>
            )}

            {!loading && fileURL && (
              <iframe
                src={fileURL}
                allowFullScreen
                className="w-full h-[66vh] sm:h-[76vh] bg-white"
              />
            )}

            {!loading && !fileURL && (
              <p className="text-xs text-cs-danger">
                Unable to load the document preview.
              </p>
            )}
          </div>

          {/* Footer */}
          <div className="flex justify-end">
            <CustomButton
              type="button"
              onClick={handleClose}
              className="
                inline-flex items-center gap-2
                px-4 py-2.5
                rounded-xl
                bg-cs-dark hover:bg-cs-primary-dark
                text-white text-sm font-medium
                shadow-sm hover:shadow-md
                transition-all
              "
            >
              <span className="material-symbols-outlined text-sm">
                close
              </span>
              Close
            </CustomButton>
          </div>
        </div>
      </div>
    </BaseModalAnimated>
  );
};

export default PreviewPDF;
